import { Text } from '@factorialco/deprecated-design-system'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const GoalsListPage = () => {
  return (
    <ResponsivePage.Body>
      <Text.Normal>Goals List</Text.Normal>
    </ResponsivePage.Body>
  )
}

export default GoalsListPage
